module.exports = __webpack_public_path__ + "static/media/Espana.bbfe2368.svg";